import {h, Fragment} from "preact"
import Products from "./Products"
import Toolbar from "./Toolbar"
import BottomToolbar from "./BottomToolbar"
import SelectedFilters from "./SelectedFilters"
import { wrapContent } from "./ContentWrapper"
import { InfiniteScroll } from "@nosto/preact"
import Loader from "./elements/Loader"
import NoResults from "./NoResults"

export function SerpBody({ loading, foundProducts, openedFacetId, setOpenedFacetId }) {
    // if (loading) return <Loader />
    // return (
    //     foundProducts ? <>
            
    //         <Toolbar openedFacetId={openedFacetId} setOpenedFacetId={setOpenedFacetId} />
    //         <Products />
    //         <BottomToolbar />
    //     </> : <NoResults />
    // )
    return (foundProducts ? (
        <>
          {/* <SelectedFilters /> */}
          <Toolbar openedFacetId={openedFacetId} setOpenedFacetId={setOpenedFacetId}/>
          <Products />
          <BottomToolbar />
         </>
       ) : loading ? (
         <Loader/> 
       ) : (
         <NoResults />
       )
    )
}

export function SerpBodyInfiniteScroll({ loading, foundProducts }) {
    if (!foundProducts) return loading ? <Loader /> : <NoResults />
    return (
        <>
            <SelectedFilters />
            <Toolbar />
            <InfiniteScroll>
                <Products />
            </InfiniteScroll>
        </>
    )
}

// replace with following line to enable infinite scroll
// export default wrapContent("search", SerpBodyInfiniteScroll)
export default wrapContent("search", SerpBody)
